import { Divider } from '@pets-ui/Divider/Divider'
import { Text } from '@pets-ui/Text/Text'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import cosignInstance from '../../../i18n/i18nConfig'

const styles = stylex.create({
  divider: {
    marginBottom: '12px',
    marginTop: '20px',
  },
})

export function DividerOr() {
  const { t } = useTranslation('translation', { i18n: cosignInstance })
  return (
    <Divider rootStyle={styles.divider}>
      <Text variant="caption">{t('login.or')}</Text>
    </Divider>
  )
}
